<template>
  <div class="role-dialog">
    <el-dialog
      title="新增角色"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form :model="formData" :rules="rules" ref="formName">
        <el-form-item
          class="management-id"
          label="角色名称"
          :label-width="formLabelWidth"
          prop="roleName"
        >
          <el-input
            v-model="formData.roleName"
            autocomplete="off"
            class="manage-id"
            placeholder="不超过十个汉字"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <div class="menu-permissions">
          <div class="menu-permissions-left">
            <span class="menu-permissions-icon">*</span
            ><span>设置角色菜单权限</span>
          </div>
          <div class="menu-permissions-right role">
            <div class="content">
              <div
                class="menu-permissions-right-box"
                v-for="(item, index) in checkboxList"
                :key="index"
              >
                <el-checkbox
                  :indeterminate="isIndeterminate"
                  v-model="parent"
                  @change="handleCheckAllChange(index, item)"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
                <el-checkbox-group v-model="parent">
                  <el-checkbox
                    v-for="citem in item.contentPermissionDTOs"
                    :key="citem.id"
                    :label="citem.id"
                    class="check-boxs-child"
                    @change="handleCheckedCitiesChange(item, citem)"
                    >{{ citem.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "newRoleDialog",
  props: ["dialogFormVisible", "formData", "checkboxList", "parentList"],
  watch: {
    "formData.roleName"(newValue, oldValue) {
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formData.roleName = this.$utils.removalSpace(newValue);
      }
    },
    dialogFormVisible(newValue, oldValue) {
      this.dialogVisible = newValue;
      if (!newValue) {
        this.$refs.formName.resetFields();
        this.checkAll = [];
      }
    },
    parentList(newValue, oldValue) {
      this.parent = newValue;
    },
    checkboxList(newValue, oldValue) {
      let arr = [];
    },
    parent(newVal, oldVal) {},
  },
  data() {
    return {
      isParent: [],
      checkAll: [],
      isDisabled: true,
      form: {
        name: "",
      },
      parent: [],
      formLabelWidth: "120px",
      dialogVisible: false,
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
      indexCheck: "",
      isIndeterminate: false,
    };
  },
  created() {},
  methods: {
    handleCheckAllChange(i, data) {
      let flag = false;
      let arr = [];
      this.parent.map((item) => {
        if (item === data.id) {
          flag = true;
        }
      });
      data.contentPermissionDTOs.map((item) => {
        arr.push(item.id);
      });
      flag
        ? arr.map((item) => {
            this.parent.push(item);
          })
        : arr.map((item) => {
            this.parent.splice(
              this.parent.indexOf(item) === -1
                ? this.parent.length + 1
                : this.parent.indexOf(item),
              1
            );
          });
    },
    handleCheckedCitiesChange(val, item) {
      let flag = false;
      let arr = val.contentPermissionDTOs.map((item) => {
        return item.id;
      });
      this.parent.map((item) => {
        arr.map((item1) => {
          if (item === item1) {
            flag = true;
          }
        });
      });
      if (flag) {
        this.parent.map((item) => {
          if (this.parent.indexOf(val.id) === -1) {
            this.parent.push(val.id);
          }
        });
      } else {
        this.parent.map((item) => {
          if (this.parent.indexOf(val.id) !== -1) {
            this.parent.splice(this.parent.indexOf(val.id), 1);
            return;
          }
        });
      }
    },
    cancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("changeDialog", false);
    },
    submit() {
      if (this.parent.length === 0) {
        return this.$message.error("至少选择一个权限");
      }
      this.$refs.formName.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.parent);
        } else {
          return false;
        }
      });
    },
    isclick(val) {},
  },
};
</script>

<style scoped lang="scss">
.menu-permissions-right-box {
  height: auto !important;
  margin-bottom: 22px;
}
.menu-permissions-right {
}
.role-dialog {
  .el-dialog {
    width: 722px;
    padding-bottom: 50px;
    position: relative;
  }

  .el-dialog .el-input__inner {
    height: 32px;
  }

  .el-dialog .el-input--suffix {
    width: 276px !important;
  }

  .el-dialog__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;
  }

  .el-dialog__header .el-dialog__title {
    font-size: 16px;
    color: #333840;
    font-weight: bolder;
  }

  .el-dialog__header .el-dialog__headerbtn {
    position: absolute;
    top: 10px;
    right: 20px;
    padding: 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
  }

  .el-dialog .management-id {
    margin-left: 60px;
    margin-top: 10px;
  }

  .el-dialog .manage-id {
    width: 276px;
    height: 32px;
  }

  .el-dialog .menu-permissions {
    display: flex;
  }

  .el-dialog .menu-permissions-left {
    width: 170px;
    padding-top: 26px;
    text-align: right;
  }

  .el-dialog .menu-permissions-right {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    width: 420px;
  }

  .el-dialog .menu-permissions-right.role {
    height: 300px;
    margin-left: 10px;
  }

  .el-dialog .menu-permissions-right.rolebox {
    height: 80px;
  }

  .el-dialog .menu-permissions-right .content {
    position: absolute;
    width: 440px;
    height: 400px;
    overflow: auto;
    padding: 0;
    margin-top: 26px;
    left: 0;
    top: 0;
    right: -17px;
    bottom: 0;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
  }

  .el-dialog .menu-permissions-right .content .check-boxs {
    margin-left: 10px;
  }

  .el-dialog .menu-permissions-right .content .check-boxs-child {
    margin-top: 15px;
    margin-left: 30px;
  }

  .el-dialog .menu-permissions-right-box {
    width: 100px;
    flex: 0 0 50%;
    height: 150px;
  }

  .el-dialog .menu-permissions-right-rolebox {
    width: 100px;
    flex: 0 0 50%;
    height: 30px;
  }

  .el-dialog .menu-permissions-icon {
    color: #f56c6c;
    margin-right: 2px;
    margin-left: 10px;
  }

  .el-dialog__footer {
    padding: 0;
    width: 100%;
    position: absolute;
    bottom: 29px;
    text-align: center;
  }

  .el-dialog__footer .el-button {
    border-radius: 0;
    width: 70px;
    height: 34px;
    line-height: 10px;
  }

  .el-dialog__footer .el-button--primary {
    background-color: dodgerblue;
    border-color: dodgerblue;
  }
}
</style>
